import { runtimeEnv } from "config/runtimeEnv";
import React, { useEffect, useState } from 'react';
import { useLoadScript } from '@react-google-maps/api';
import useWebSocket from 'react-use-websocket';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import { getAssignDriver, getTrip, postCancelTrip } from 'redux/actions/UserTrip';
import { updateAssignDriver } from 'redux/actions/UserAllot';
import { getDriver } from 'redux/actions/UserDriver';
import PickUp from 'components/pickAndDrop/PickUp';
import WrappedMap from 'components/commonMap/CommonMap';
import Loader from 'components/loader/Loader';
import ConfirmationDialog from 'components/confirmationDialog/ConfirmationDialog';
import { API_ENDPOINT } from 'services/Api';
import AssignedDriver from './AssignDriver';
import { data } from './RideTrackData';
import rideTrackError from 'assets/images/tripErrorImg.svg'
import star from 'assets/images/smStar.svg';


const RideTrackView = () => {
  const token = localStorage.getItem('token')
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: runtimeEnv("GOOGLE_API_KEY"),
  });
  const dispatch = useDispatch();
  const {state} = useLocation();

  const id = state?.id;
  const type = state?.type;
  const tripId = state?.tripId
  const tabType = state?.tabType

  const userId = localStorage.getItem('ID')
  const [isMap, setIsMap] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const driverData = useSelector((state) => state?.userDriver?.userDriver?.data);
  const assignDriverData = useSelector((state) => state?.userAssignDriver?.userAssignDriver?.data)
  const assignDriverLoader = useSelector((state) => state?.userAssignDriver?.loading)
  const [filterDrivers, setFilterDrivers] = useState(driverData?.body);
  const tripDetails = useSelector((state) => state?.userTrip?.userTrip?.data);
  const loader = useSelector((state) => state?.userTrip?.loading);
  const tripRoute = useSelector((state) => state?.userTrip?.userTrip?.data?.polyLine?.coordinates[0]);
  const filterData = {
    id: id,
    status: '',
    page: '',
    pageSize: '',
    date: '',
    type: type,
  };
  let tripCoordinate = tripRoute?.map((trip) => ({
    lat: trip?.[0],
    lng: trip?.[1]
  }))

  const status = tripDetails?.status ? tripDetails?.status : state?.status;
  let mapURL
  if (
    status?.toLocaleLowerCase() === "ongoing" ||
    status?.toLocaleLowerCase() === "dispatched"
  ) {
    mapURL = `${API_ENDPOINT?.MapApi?.api}js?v=3.exp&libraries=geometry,drawing,places&key=${runtimeEnv("GOOGLE_API_KEY")}`;
  }
  let startlocation = tripDetails?.sourceLocation;

  let endLocation = tripDetails?.destinationLocation;
  let stop = [
      { lat: startlocation?.coordinates[0], lng: startlocation?.coordinates[1] }
    , { lat: endLocation?.coordinates[0], lng: endLocation?.coordinates[1] }
  ]
  const [confirmDialog, setConfirmDialog] = useState(false);

  // Re-Assign state
  const [isReAssign, setIsReAssign] = useState(false);
  const [reAssignReason, setReAssignReason] = useState("");
  const [reAssignReasonOpen, setReAssignReasonOpen] = useState(false);
  const [currentDriverId, setCurrentDriverId] = useState(null);
  const [pendingReAssignData, setPendingReAssignData] = useState(null);

  const mainSocketUrl = runtimeEnv("WEBSOCKET_URL")+'?tripId='+tripId+'&authToken='+token

  const handleImgError =(e) => {
    e.target.src = rideTrackError
  }

  const [pathDetails, setPathDetails] = useState([]);

  useEffect(() => {
    dispatch(getTrip(filterData));
  }, []);

  
  const onCloseIcon = () => {
    setIsMap(false);
  };
  const onLiveLocation = () => {
    setIsMap(true);
  };
  const breadcrumbPaths = [
    { name: 'Trip', url: '/rideTrack/2', className: 'colorGrey fontSemi' },
    { name: tripId?.toUpperCase(), url: '', className: 'colorBlue' },
  ];
  useEffect(() => {
    setFilterDrivers(driverData?.body)
  }, [driverData])

  let filterDataDriver = {
    assignId: userId,
    status: status,
    page: "",
    pageSize: "",
    type: ""
  }
  useEffect(() => {
    dispatch(getDriver(filterDataDriver))
  }, [])

  const onClickAssign = (data, reAssign = false) => {
    if (reAssign && data?.DriverProfile) {
      // Re-assign: collect reason first, then open driver dialog
      setPendingReAssignData(data);
      setCurrentDriverId(
        data?.DriverProfile?.id ||
        data?.DriverProfile?.driverId ||
        null
      );
      setIsReAssign(true);
      setReAssignReasonOpen(true);
    } else {
      // First assign: open driver dialog directly
      setIsReAssign(false);
      setCurrentDriverId(null);
      dispatch(getAssignDriver({tripId: data?.id}));
      setOpenDialog(true);
      setSearchQuery('');
    }
  };

  const onReAssignReasonConfirm = (reason) => {
    setReAssignReason(reason);
    setReAssignReasonOpen(false);
    dispatch(getAssignDriver({tripId: pendingReAssignData?.id}));
    setOpenDialog(true);
    setSearchQuery('');
  };

  const handleClose = () => {
    setOpenDialog(false);
    setIsReAssign(false);
    setReAssignReason("");
    setCurrentDriverId(null);
    setPendingReAssignData(null);
  };
  const handleSearch = (val) => {
    setSearchQuery(val);
  };
  const filterAllDrivers = () => {
    let filteredDriverList = assignDriverData || [];
    // Filter by search query
    if (searchQuery !== "") {
      filteredDriverList = filteredDriverList.filter(driver =>
        (driver.driverName || driver.name || "").toLowerCase().includes(searchQuery?.toLowerCase())
      );
    }
    // On re-assign: exclude the currently assigned driver
    if (isReAssign && currentDriverId) {
      filteredDriverList = filteredDriverList.filter(driver => {
        const dId = driver.id || driver.driverId || driver._id;
        return dId !== currentDriverId;
      });
    }
    setFilterDrivers(filteredDriverList);
  };
  const submitAssign = (data) => {
    const selectedDriverId = data?.id || data?.driverId || data?._id;
    if (selectedDriverId === currentDriverId) {
      toast.error("This driver is already assigned to this trip. Please select a different driver.");
      return;
    }

    const val = {
      tripId: id,
      driverId: data?.id,
      status: 'assignTrip',
      rideTrip: true,
      driverData: filterDataDriver,
    };
    // Pass reason for re-assign
    if (isReAssign && reAssignReason) {
      val.reason = reAssignReason;
    }
    dispatch(updateAssignDriver(val));
    handleClose();
  };

  useEffect(() => {
    filterAllDrivers();
  }, [searchQuery, isReAssign, assignDriverData]);

  useWebSocket(mainSocketUrl, {
    // here console is required for websocket connection
    onOpen : (e) =>{console.log("WebSocket is Connected ...!!!")},
    onMessage : (event) =>{
      const eventData = JSON.parse(event.data)
      if((status?.toLowerCase() === 'ongoing' || status?.toLowerCase() === 'dispatched')){
        if(eventData?.location?.lat && eventData?.location?.lat !== null){
          setPathDetails(eventData)
        }
      }
      else if(status?.toLowerCase() !== 'ongoing' && status?.toLowerCase() !== 'dispatched'){
        setPathDetails()
      }   
    },
    onClose : () =>{console.log("WebSocket is Disconnected ...$$$")}
  }) 

  const onCancel = () => {
    setConfirmDialog(true)
  }

  const handleCloseConfirm = () => {
    setConfirmDialog(false)
  }
  
  const handleSubmit = () => {
    dispatch(postCancelTrip({id}))
    setConfirmDialog(false)
  }


  return (
    <>
      {loader? 
        <Loader/> 
        :
        <div>
          <CommonBreadCrumb paths={breadcrumbPaths} tabType={tabType} />
          {(status?.toLowerCase() === 'ongoing' || status?.toLowerCase() === 'dispatched') && isMap && <Grid className="invoiceStyle">Taxi Live Location</Grid>}
          {(status?.toLowerCase() === 'ongoing' || status?.toLowerCase() === 'dispatched') && isMap && (
            <div className="rideTrackStyle">
              <div
                className="iconPosition cursor"
                onClick={(e) => {
                  onCloseIcon();
                }}
              >
                <CloseIcon />
              </div>
              <div className="mapStyle">
                {!isLoaded ? (
                  <h1>Loading...</h1>
                ) : (
                  tripCoordinate?.length > 0 && (
                    status?.toLocaleLowerCase() === "ongoing" ||
                    status?.toLocaleLowerCase() === "dispatched"
                  ) && <WrappedMap
                    paths={tripCoordinate}
                    driverPathDetails = {pathDetails}
                    stops={stop}
                    googleMapURL={mapURL}
                    loadingElement={<div className='height100'/>}
                    containerElement={<div className='mapContainer' />}
                    mapElement={<div className='height100'/>}
                    status={status}
                  />
                )}
              </div>
            </div>
          )}
          {status?.toLowerCase() === 'completed' && isMap &&
        
            <div className="rideTrackStyle">
              <div
                className="iconPosition cursor"
                onClick={(e) => {
                  onCloseIcon();
                }}
              >
                <CloseIcon />
              </div>
            
          <div className="mapStyle">
            <img className="mapStyle" src={tripDetails?.tripRouteImage?.url? tripDetails?.tripRouteImage?.url : rideTrackError} alt='Ride completed' onError={handleImgError}/>
          </div>
          </div>
          }
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="start"
          >
            {/* 1st Section */}
            <Grid item container sm={12} md={8} className="paddingTRB20">
              <Grid
                item
                container
                sm={12}
                md={12}
                className="padding20 borderStyle"
              >
                <Grid
                  item
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid container direction="row" justifyContent="space-between"
                  alignItems="start" item md={12} sm={12}>
                    <div className='flexAlignStart'>
                    <div className="font14 fontNormal colorGrey">
                      {'Customer : '}
                    </div>
                    <div
                      className="font14 fontNormal colorGrey marginInline10"
                    >
                      <span className="headinCustomer">{tripDetails?.DemandProfile?.name}</span>
                      <br />
                      {"Trip Id: " + tripDetails?.tripId}
                      {tripDetails?.DemandProfile?.rating && <span>
                        <img
                          src={star}
                          alt="star"
                          className="feedbackStar marginInline10"
                        />
                        {tripDetails?.DemandProfile?.rating}
                      </span>}
                      <br />
                      <span className="font14 fontNormal colorBlue">{'₹' + tripDetails?.price}</span>
                    </div>
                    </div>
                    <Grid item xs={3} className="liveBtnStyle">
                      {(status?.toLowerCase() === 'ongoing' || status?.toLowerCase() === 'dispatched') && !isMap && (
                        <div>
                        <Button
                          className="textTransform liveBg"
                          onClick={() => onLiveLocation()}
                        >
                          Live Location
                        </Button>
                        </div>
                      )}
                      {status?.toLowerCase() === 'completed' && !isMap && (
                        <Button
                          className="textTransform liveBg"
                          onClick={() => onLiveLocation()}
                        >
                          Location
                        </Button>
                      )}
                      <Button className={`textTransform fontMedium font14 ${status + 'Btn'}`}>
                        {status}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} className="feedbackBrief">
                  <PickUp tableData={tripDetails} />
                </Grid>
              </Grid>
            </Grid>

            {/* 2nd section */}
            <Grid item container sm={12} md={4} className="padding20">
              <Grid item container sm={12} md={12} className="borderStyle">
                <AssignedDriver
                  status={status}
                  tableData={tripDetails}
                  submitAssign={submitAssign}
                  handleSearch={handleSearch}
                  openDialog={openDialog}
                  filterDrivers={filterDrivers?.length > 0 ? filterDrivers : []}
                  onClickAssign={onClickAssign}
                  handleClose={handleClose}
                  onCancel={onCancel}
                  assignDriverLoader={assignDriverLoader}
                  isReAssign={isReAssign}
                />
              </Grid>
            </Grid>
            {tripDetails?.invoiceData && <Grid className="invoiceStyle">Invoice</Grid>}
            {tripDetails?.invoiceData && <Grid item xs={12} className="mainContainerInvoice">
              <Grid container className="containerRide">
                <Grid item xs={2} className="rideHeader">
                  Date
                </Grid>
                <Grid item xs={3} className="rideHeader">
                  Description
                </Grid>
                <Grid item xs={2} className="rideHeader">
                  Charges
                </Grid>
                <Grid item xs={2} className="rideHeader">
                  Tax
                </Grid>
                <Grid item xs={3} className="rideHeader">
                  Amount
                </Grid>
              </Grid>
              {data?.map((val, idx) => (
                <Grid container key={val.date} className="containerRideDesc">
                  <Grid item xs={2} className="rideDesc">
                    {val.date}
                  </Grid>
                  <Grid item xs={3} className="rideDesc">
                    {val.description}
                  </Grid>
                  <Grid item xs={2} className="rideDesc">
                    {val.charges}
                  </Grid>
                  <Grid item xs={2} className="rideDesc">
                    {val.tax}
                  </Grid>
                  <Grid item xs={3} className="rideDesc">
                    {val.amount}
                  </Grid>
                </Grid>
              ))}
              <Grid container className="containerRideTotal">
                <Grid item xs={3}>
                  {/* TODO : need to use dynamic data as of now we are not showing invoice for each track trip */}
                  <div className="rideDesc">
                    Sub Total Amount : ₹2009
                  </div>
                  <div className="rideDesc">Discount : </div>
                  <div className="rideDesc">Tax : ₹30 </div>
                  <div className="rideDescTotal">
                    Total Amount : 2000
                  </div>
                </Grid>
              </Grid>
            </Grid>}
          </Grid>
        </div>
      }
      {confirmDialog &&
        <ConfirmationDialog
          open={confirmDialog}
          handleSubmit={handleSubmit}
          handleClose={handleCloseConfirm}
        />
      }

      {/* Re-Assign Reason Dialog */}
      <Dialog
        open={reAssignReasonOpen}
        onClose={() => { setReAssignReasonOpen(false); setIsReAssign(false); }}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: "12px", p: 1 } }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "18px", color: "#1a237e" }}>
          Reason for Re-Assignment
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Please specify why you are re-assigning this trip to a different driver.
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="Re-Assignment Reason"
            type="text"
            fullWidth
            variant="outlined"
            value={reAssignReason}
            onChange={(e) => setReAssignReason(e.target.value)}
            required
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => { setReAssignReasonOpen(false); setIsReAssign(false); }}
            sx={{ color: "grey.600", textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => onReAssignReasonConfirm(reAssignReason)}
            variant="contained"
            color="primary"
            disabled={!reAssignReason.trim()}
            sx={{ borderRadius: "8px", px: 3, textTransform: "none" }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default RideTrackView;